/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */
export const LIMIT_REACHED = 'LIMIT_REACHED';
/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const PROVIDER_USER = 'PROVIDER_USER';
/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const TEST_PORTAL_USER = 'TEST_PORTAL_USER'; // App Reviewability only

/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const ALREADY_REVIEWED = 'ALREADY_REVIEWED';
/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const PUBLIC_USER = 'PUBLIC_USER';
/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const NOT_INSTALLED = 'NOT_INSTALLED';
/** @deprecated use UnreviewableReason.ts in marketplace-ui-reviews */

export const UNINSTALLED = 'UNINSTALLED';